// All kiosk/HR portal API calls go to /api/kiosk/
// Uses the same BHEL access_token — no separate kiosk token needed
const BASE = '/api/kiosk';

export function getToken() {
  // Always use the BHEL login token
  return localStorage.getItem('access_token');
}

export function setToken(t) {
  // No-op: token is managed by BHEL auth, not us
}

export async function api(path, opts = {}) {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json', ...opts.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const r = await fetch(BASE + path, { ...opts, headers });
  const data = await r.json().catch(() => ({}));
  if (r.status === 401 && !path.includes('/login')) {
    throw new Error('Session expired — please log in again');
  }
  if (!r.ok) throw new Error(data.detail || 'Request failed');
  return data;
}

export async function apiBlob(path) {
  const token = getToken();
  const r = await fetch(BASE + path, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!r.ok) throw new Error('not found');
  return URL.createObjectURL(await r.blob());
}
